import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  Auth: false,
  Id: null,
  Rol: [],
  Token: null,
  Username: null,
  Name: null,
  Rol_Type: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserInfo(state, action) {
      const user = action.payload;
      const roles = user.rol.split(",");
      
      state.Auth = true;
      state.Id = user.id;
      state.Rol = roles;
      state.Token = user.token;
      state.Username = user.kullanici_adi;
      state.Name = user.isim_soyisim;
      state.Rol_Type = user.rol_kimlik;
    },
    clearUserInfo() {
      return initialState;
    },
  },
});

export const { setUserInfo, clearUserInfo } = userSlice.actions;
export default userSlice.reducer;
